/**
 * @generated SignedSource<<3a62d4390ee62bef05f5cd43e82930d4>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type HotelEditTabs_data$data = {
  readonly " $fragmentSpreads": FragmentRefs<"HotelEditMain_data">;
  readonly " $fragmentType": "HotelEditTabs_data";
};
export type HotelEditTabs_data$key = {
  readonly " $data"?: HotelEditTabs_data$data;
  readonly " $fragmentSpreads": FragmentRefs<"HotelEditTabs_data">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "HotelEditTabs_data",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "HotelEditMain_data"
    }
  ],
  "type": "Query",
  "abstractKey": null
};

(node as any).hash = "af0dc8e474163c39d78ea5a205dc8737";

export default node;
